/**
 * Development-only logging utility
 * Logs are only output in development mode to prevent sensitive data exposure in production
 */
export const debugLog = (...args: unknown[]) => {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
};

export const debugInfo = (...args: unknown[]) => {
  if (import.meta.env.DEV) {
    console.info(...args);
  }
};

export const debugWarn = (...args: unknown[]) => {
  if (import.meta.env.DEV) {
    console.warn(...args);
  }
};